import {EntityUnfollowedEvent} from './EntityUnfollowedEvent';

export class CompetitionUnfollowed extends EntityUnfollowedEvent {}
